import { render, staticRenderFns } from "./FormTopSection.vue?vue&type=template&id=2193f8fd"
import script from "./FormTopSection.vue?vue&type=script&lang=ts"
export * from "./FormTopSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports